"use strict";
/**
 * AUTOGENERATED
 *
 * DO NOT MODIFY
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.IO = void 0;
exports.IO = {
    numericCode: '086',
    alpha2Code: 'IO',
    alpha3Code: 'IOT',
    englishName: {
        short: 'British Indian Ocean Territory (the)',
        full: 'British Indian Ocean Territory (the)',
    },
    names: {
        full: {
            fr: "le Territoire britannique de l'océan Indien",
            en: 'British Indian Ocean Territory (the)',
        },
        short: {
            fr: "Indien (le Territoire britannique de l'océan)",
            en: 'British Indian Ocean Territory (the)',
        },
    },
    languages: [
        {
            languageAlpha2Code: 'en',
            languageAlpha3Code: 'eng',
            isAdministrative: true,
        },
        {
            languageAlpha2Code: 'fr',
            languageAlpha3Code: 'fra',
            isAdministrative: false,
        },
    ],
    subdivisions: {},
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiSU8uanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvY291bnRyaWVzL2RhdGEvSU8udHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IjtBQUFBOzs7O0dBSUc7OztBQU1VLFFBQUEsRUFBRSxHQUFZO0lBQ3ZCLFdBQVcsRUFBRSxLQUFLO0lBQ2xCLFVBQVUsRUFBRSxJQUFJO0lBQ2hCLFVBQVUsRUFBRSxLQUFLO0lBQ2pCLFdBQVcsRUFBRTtRQUNULEtBQUssRUFBRSxzQ0FBc0M7UUFDN0MsSUFBSSxFQUFFLHNDQUFzQztLQUMvQztJQUNELEtBQUssRUFBRTtRQUNILElBQUksRUFBRTtZQUNGLEVBQUUsRUFBRSw2Q0FBNkM7WUFDakQsRUFBRSxFQUFFLHNDQUFzQztTQUM3QztRQUNELEtBQUssRUFBRTtZQUNILEVBQUUsRUFBRSwrQ0FBK0M7WUFDbkQsRUFBRSxFQUFFLHNDQUFzQztTQUM3QztLQUNKO0lBQ0QsU0FBUyxFQUFFO1FBQ1A7WUFDSSxrQkFBa0IsRUFBRSxJQUFJO1lBQ3hCLGtCQUFrQixFQUFFLEtBQUs7WUFDekIsZ0JBQWdCLEVBQUUsSUFBSTtTQUN6QjtRQUNEO1lBQ0ksa0JBQWtCLEVBQUUsSUFBSTtZQUN4QixrQkFBa0IsRUFBRSxLQUFLO1lBQ3pCLGdCQUFnQixFQUFFLEtBQUs7U0FDMUI7S0FDSjtJQUNELFlBQVksRUFBRSxFQUFFO0NBQ25CLENBQUEifQ==